"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll/modules/mixins/scroll-events.js
// module id = 33
// module chunks = 35783957827783 114276838955818 161653746587813